module.exports = __webpack_public_path__ + "resources/img/logo_tmon.77809d4264bd69e30473d651c117f7a0.png";